import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
// import { useSelectorOptionsSync } from "../hooks/useSelectorOptionsSync";
/**
 * In development mode, update selector options based on debug settings
 * @private
 * @category Controller
 * @param props
 * @returns
 */
export function SelectorOptionsSync() {
    // FIXME causes problems with additional fetch
    // useSelectorOptionsSync();
    return _jsx(Fragment, {});
}
//# sourceMappingURL=SelectorOptionsSync.js.map